import { z } from "zod";
import { getPartnershipParamSchema } from "./get-partnership.schema";

export const getPartnershipReferenceParamSchema = z
	.object({
		referenceId: z.string().uuid(),
	})
	.and(getPartnershipParamSchema);

export type GetPartnershipReferenceParamSchema = z.infer<typeof getPartnershipReferenceParamSchema>;
